var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import _ from 'lodash';
import assert from 'assert';

import PropertyInfo from './PropertyInfo';

var DataItem = function () {
    function DataItem(dataItemDescriptorObj, propertyInfo, onChange) {
        _classCallCheck(this, DataItem);

        assert(propertyInfo instanceof PropertyInfo);

        this._descriptor = dataItemDescriptorObj;
        this._propInfo = propertyInfo;
        this._onChange = typeof onChange === 'function' ? onChange : _.noop;
        this._hasItemChanged = false;
    }

    _createClass(DataItem, [{
        key: 'asCommited',
        value: function asCommited() {
            if (this._asCommited) {
                return this._asCommited;
            }

            var CurrentDataItem = this.constructor;
            this._asCommited = new CurrentDataItem(this.describe(), this.getPropertyInfo(), null);
            return this.asCommited();
        }
    }, {
        key: 'getVM',
        value: function getVM() {
            if (this._vm) {
                return this._vm;
            }

            var item = this;
            this._vm = {
                aspects: {
                    get valid() {
                        return item.isValid();
                    },
                    get required() {
                        return item.getPropertyInfo().isRequired();
                    }
                },

                get value() {
                    return item.getValue();
                },
                set value(val) {
                    item.setValue(val);
                }
            };

            return this.getVM();
        }
    }, {
        key: '_getValue',
        value: function _getValue() {
            return this._descriptor[DataItem.typeToPropertyName(this.getType())];
        }
    }, {
        key: 'getValue',
        value: function getValue() {
            if (this.isDrafted()) {
                return this._draft;
            }

            return this._getValue();
        }
    }, {
        key: '_setValue',
        value: function _setValue(val) {
            this._descriptor[DataItem.typeToPropertyName(this.getType())] = val;
            this._onChange();
            this._hasItemChanged = true;
        }
    }, {
        key: 'setValue',
        value: function setValue(val) {
            if (this.isDrafted()) {
                this._draft = val;
            } else {
                this._setValue(val);
            }

            return this;
        }
    }, {
        key: 'getChangedStatus',
        value: function getChangedStatus() {
            return this._hasItemChanged;
        }
    }, {
        key: 'resetChangedStatus',
        value: function resetChangedStatus() {
            this._hasItemChanged = false;
        }
    }, {
        key: 'draft',
        value: function draft() {
            this._drafted = true;
            this._draft = _.cloneDeep(this._getValue());
        }
    }, {
        key: 'isDrafted',
        value: function isDrafted() {
            return this._drafted;
        }
    }, {
        key: '_undraft',
        value: function _undraft() {
            this._drafted = false;
        }
    }, {
        key: 'commit',
        value: function commit() {
            assert(this.isDrafted(), 'Can not commit item that is not drafted');
            this._setValue(this._draft);
            this._undraft();
        }
    }, {
        key: 'undo',
        value: function undo() {
            assert(this.isDrafted(), 'Can not undo on an item that is not drafted');
            this._undraft();
        }
    }, {
        key: 'getPropertyInfo',
        value: function getPropertyInfo() {
            return this._propInfo;
        }
    }, {
        key: 'getType',
        value: function getType() {
            return this._propInfo.getType();
        }
    }, {
        key: 'getName',
        value: function getName() {
            return this._propInfo.getName();
        }
    }, {
        key: 'getAvailableValues',
        value: function getAvailableValues() {
            return this._propInfo.getAvailableValues();
        }
    }, {
        key: 'isEditable',
        value: function isEditable() {
            return this._propInfo.isEditable();
        }
    }, {
        key: 'getErrors',
        value: function getErrors() {
            // Can only check requiredness at this point
            if (!this.getPropertyInfo().isRequired()) {
                return [];
            }

            // uniqueness check
            if (this.getPropertyInfo().isUnique() && this.getValue()) {
                return this.getPropertyInfo().checkDataItemIsUniqueInSchedule(this) ? [] : ['policycommon.directives.schedules.dataItem.This field must be unique'];
            }

            if (this.getValue()) {
                return []; // Required and has value
            }

            return ['policycommon.directives.schedules.dataItem.This is a required field'];
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            return this.getErrors().length === 0;
        }
    }, {
        key: 'describe',
        value: function describe() {
            return this._descriptor;
        }
    }], [{
        key: 'typeToPropertyName',
        value: function typeToPropertyName(type) {
            switch (type) {
                case 'INTEGER':
                    return 'integerValue';
                case 'TYPEKEY':
                    return 'typeCodeValue';
                case 'STRING':
                    return 'stringValue';
                default:
                    throw new Error('No mapping for type: ' + type);
            }
        }
    }]);

    return DataItem;
}();

export default DataItem;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/models/schedules/DataItem.js
// module id = 106
// module chunks = 0